import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    windheight: '',
    userid: localStorage.getItem('userid') ? localStorage.getItem('userid') : '',
    username: localStorage.getItem('suName') ? localStorage.getItem('suName') : '',
    postname: localStorage.getItem('postname') ? localStorage.getItem('postname') : '',
    post: localStorage.getItem('post') ? localStorage.getItem('post') : '',
    authRoter: localStorage.getItem('authRoter') ? localStorage.getItem('authRoter') : '',
    account: localStorage.getItem('account') ? localStorage.getItem('account') : '',
  },
  mutations: {
    changeuser(state, user) {
      state.userid = user.userid.suId;
      state.username = user.userid.suName;
      state.postname = user.userid.suPostName;
      state.post = user.userid.suPost;
      state.account = user.userid.suAccount;
      state.authRoter = JSON.stringify( user.userid.ayRoleAuthList)
      localStorage.setItem('userid', user.userid.suId);
      localStorage.setItem('suName', user.userid.suName);
      localStorage.setItem('postname', user.userid.suPostName);
      localStorage.setItem('post', user.userid.suPost);
      localStorage.setItem('account', user.userid.suAccount);
      localStorage.setItem('authRoter', JSON.stringify( user.userid.ayRoleAuthList));
    },
    getWindowHeight(state, data) {
      state.windheight = data.windheight;
    }
  },
  actions: {
  },
  modules: {
  }
})
